import { isBoolean, isNumber, isString, mapValues } from "lodash-es";

import { toKebabCase } from "@/utils/text";

export function normalizeEventData(data) {
  return mapValues(withDefaults(data), process);
}

function withDefaults(data) {
  return {
    ...data,
    inline: new URLSearchParams(document.location.search).has("noNav") ? true : undefined,
  };
}

// formats and validates a single event datum
function process(value) {
  if (isNumber(value)) {
    if (!isFinite(value)) {
      throw Error(`invalid number: ${value}`);
    }
    return value;
  }
  if (isString(value)) {
    return toKebabCase(value);
  }
  if (isBoolean(value) || value === null || value === undefined) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(process);
  }
  throw Error(`value of invalid type: ${JSON.stringify(value)}`);
}
